var _defs, _use, _use2, _use3, _use4, _use5, _use6, _g, _use7, _use8, _use9, _use10, _use11, _use12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "AnimatedIcon__icon",
    width: 96,
    height: 96,
    preserveAspectRatio: "xMinYMin",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    "data-js-controller": "NodesIcon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "nodesIconSegment",
    d: "M20 41.15l9.7 5.55a1.5 1.5 0 0 1 0 2.6L20 54.85v-13.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nodesIconDot",
    cx: 34,
    cy: 48,
    r: 6
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "nodesIconClipPath"
  }, /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__dot",
    href: "#nodesIconDot",
    x: 0,
    y: -24,
    "data-js-target-list": "NodesIcon.clipPathDots"
  }), /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__dot",
    href: "#nodesIconDot",
    x: 21,
    y: -12,
    "data-js-target-list": "NodesIcon.clipPathDots"
  }), /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__dot",
    href: "#nodesIconDot",
    x: 21,
    y: 12,
    "data-js-target-list": "NodesIcon.clipPathDots"
  }), /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__dot",
    href: "#nodesIconDot",
    x: 0,
    y: 24,
    "data-js-target-list": "NodesIcon.clipPathDots"
  }), /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__dot",
    href: "#nodesIconDot",
    x: -21,
    y: 12,
    "data-js-target-list": "NodesIcon.clipPathDots"
  }), /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__dot",
    href: "#nodesIconDot",
    x: -21,
    y: -12,
    "data-js-target-list": "NodesIcon.clipPathDots"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "nodesIconDot",
    cx: 34,
    cy: 48,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nodesIconDot",
    cx: 34,
    cy: 48,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nodesIconDot",
    cx: 34,
    cy: 48,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nodesIconDot",
    cx: 34,
    cy: 48,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nodesIconDot",
    cx: 34,
    cy: 48,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nodesIconDot",
    cx: 34,
    cy: 48,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "nodesIconSegment",
    d: "M20 41.15l9.7 5.55a1.5 1.5 0 0 1 0 2.6L20 54.85v-13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nodesIconSegment",
    d: "M20 41.15l9.7 5.55a1.5 1.5 0 0 1 0 2.6L20 54.85v-13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nodesIconSegment",
    d: "M20 41.15l9.7 5.55a1.5 1.5 0 0 1 0 2.6L20 54.85v-13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nodesIconSegment",
    d: "M20 41.15l9.7 5.55a1.5 1.5 0 0 1 0 2.6L20 54.85v-13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nodesIconSegment",
    d: "M20 41.15l9.7 5.55a1.5 1.5 0 0 1 0 2.6L20 54.85v-13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nodesIconSegment",
    d: "M20 41.15l9.7 5.55a1.5 1.5 0 0 1 0 2.6L20 54.85v-13.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nodesIconDot",
    cx: 34,
    cy: 48,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nodesIconDot",
    cx: 34,
    cy: 48,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nodesIconDot",
    cx: 34,
    cy: 48,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nodesIconDot",
    cx: 34,
    cy: 48,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nodesIconDot",
    cx: 34,
    cy: 48,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nodesIconDot",
    cx: 34,
    cy: 48,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "nodesIconSegment",
    d: "M20 41.15l9.7 5.55a1.5 1.5 0 0 1 0 2.6L20 54.85v-13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nodesIconSegment",
    d: "M20 41.15l9.7 5.55a1.5 1.5 0 0 1 0 2.6L20 54.85v-13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nodesIconSegment",
    d: "M20 41.15l9.7 5.55a1.5 1.5 0 0 1 0 2.6L20 54.85v-13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nodesIconSegment",
    d: "M20 41.15l9.7 5.55a1.5 1.5 0 0 1 0 2.6L20 54.85v-13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nodesIconSegment",
    d: "M20 41.15l9.7 5.55a1.5 1.5 0 0 1 0 2.6L20 54.85v-13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nodesIconSegment",
    d: "M20 41.15l9.7 5.55a1.5 1.5 0 0 1 0 2.6L20 54.85v-13.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "NodesIcon__segments"
  }, /*#__PURE__*/React.createElement("g", {
    className: "NodesIcon__segmentRotator",
    style: {
      transform: "rotate(0deg)"
    },
    "data-js-target-list": "NodesIcon.segmentRotators"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__segment",
    href: "#nodesIconSegment",
    fill: "#80E9FF",
    "data-js-target-list": "NodesIcon.segments"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "NodesIcon__segmentRotator",
    style: {
      transform: "rotate(60deg)"
    },
    "data-js-target-list": "NodesIcon.segmentRotators"
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__segment",
    href: "#nodesIconSegment",
    fill: "#80E9FF",
    "data-js-target-list": "NodesIcon.segments"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "NodesIcon__segmentRotator",
    style: {
      transform: "rotate(120deg)"
    },
    "data-js-target-list": "NodesIcon.segmentRotators"
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__segment",
    href: "#nodesIconSegment",
    fill: "#80E9FF",
    "data-js-target-list": "NodesIcon.segments"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "NodesIcon__segmentRotator",
    style: {
      transform: "rotate(180deg)"
    },
    "data-js-target-list": "NodesIcon.segmentRotators"
  }, _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__segment",
    href: "#nodesIconSegment",
    fill: "#80E9FF",
    "data-js-target-list": "NodesIcon.segments"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "NodesIcon__segmentRotator",
    style: {
      transform: "rotate(240deg)"
    },
    "data-js-target-list": "NodesIcon.segmentRotators"
  }, _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__segment",
    href: "#nodesIconSegment",
    fill: "#80E9FF",
    "data-js-target-list": "NodesIcon.segments"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "NodesIcon__segmentRotator",
    style: {
      transform: "rotate(300deg)"
    },
    "data-js-target-list": "NodesIcon.segmentRotators"
  }, _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__segment",
    href: "#nodesIconSegment",
    fill: "#80E9FF",
    "data-js-target-list": "NodesIcon.segments"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "NodesIcon__dots"
  }, /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__dot",
    href: "#nodesIconDot",
    x: 0,
    y: -24,
    fill: "#7A73FF",
    "data-js-target-list": "NodesIcon.dots"
  }), /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__dot",
    href: "#nodesIconDot",
    x: 21,
    y: -12,
    fill: "#7A73FF",
    "data-js-target-list": "NodesIcon.dots"
  }), /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__dot",
    href: "#nodesIconDot",
    x: 21,
    y: 12,
    fill: "#7A73FF",
    "data-js-target-list": "NodesIcon.dots"
  }), /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__dot",
    href: "#nodesIconDot",
    x: 0,
    y: 24,
    fill: "#7A73FF",
    "data-js-target-list": "NodesIcon.dots"
  }), /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__dot",
    href: "#nodesIconDot",
    x: -21,
    y: 12,
    fill: "#7A73FF",
    "data-js-target-list": "NodesIcon.dots"
  }), /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__dot",
    href: "#nodesIconDot",
    x: -21,
    y: -12,
    fill: "#7A73FF",
    "data-js-target-list": "NodesIcon.dots"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#nodesIconClipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "NodesIcon__segmentRotator",
    style: {
      transform: "rotate(0deg)"
    },
    "data-js-target-list": "NodesIcon.segmentRotators"
  }, _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__segment",
    href: "#nodesIconSegment",
    fill: "#0048E5",
    "data-js-target-list": "NodesIcon.segments"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "NodesIcon__segmentRotator",
    style: {
      transform: "rotate(60deg)"
    },
    "data-js-target-list": "NodesIcon.segmentRotators"
  }, _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__segment",
    href: "#nodesIconSegment",
    fill: "#0048E5",
    "data-js-target-list": "NodesIcon.segments"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "NodesIcon__segmentRotator",
    style: {
      transform: "rotate(120deg)"
    },
    "data-js-target-list": "NodesIcon.segmentRotators"
  }, _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__segment",
    href: "#nodesIconSegment",
    fill: "#0048E5",
    "data-js-target-list": "NodesIcon.segments"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "NodesIcon__segmentRotator",
    style: {
      transform: "rotate(180deg)"
    },
    "data-js-target-list": "NodesIcon.segmentRotators"
  }, _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__segment",
    href: "#nodesIconSegment",
    fill: "#0048E5",
    "data-js-target-list": "NodesIcon.segments"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "NodesIcon__segmentRotator",
    style: {
      transform: "rotate(240deg)"
    },
    "data-js-target-list": "NodesIcon.segmentRotators"
  }, _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__segment",
    href: "#nodesIconSegment",
    fill: "#0048E5",
    "data-js-target-list": "NodesIcon.segments"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "NodesIcon__segmentRotator",
    style: {
      transform: "rotate(300deg)"
    },
    "data-js-target-list": "NodesIcon.segmentRotators"
  }, _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    className: "NodesIcon__segment",
    href: "#nodesIconSegment",
    fill: "#0048E5",
    "data-js-target-list": "NodesIcon.segments"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.e219d94feff5af34fef596ba3bfcc554.svg";
export { ForwardRef as ReactComponent };